import { ColumnBib, ColumnStartOrder, ColumnNoc, ColumnName, ColumnExpander } from "components/common/TableColumns"
import { ColumnRound, ColumnTotalPoints } from "components/sports/sjp/events/individual/resultsFinal/Columns"

export function TableColumns1Round() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnTotalPoints({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumns1RoundSM() {

    return (
        [
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnTotalPoints({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinalRound() {

    return (
        [
            ColumnStartOrder({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0" }),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1" }),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinalRoundSM() {

    return (
        [
            ColumnStartOrder({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnRound({ roundNumber: "0" }),
            ColumnRound({ label: "HeaderFinalRound", roundNumber: "1" }),
            ColumnTotalPoints({}),
            ColumnExpander({})
        ]
    )
}

function PlayerStatsType({ round, rank }) {
    if (round !== undefined && rank !== undefined) 
    {
      return (
        <>
          {round} ({rank})
        </>
      )
    }
}

export default TableColumns1Round

